<template>
  <main>
    <select-field :error="jobBoardError" v-model="jobBoard" :label="this.$t('jobs.selectJobBoard')"
                  :options="jobBoards" :defaultOption="this.$t('jobs.selectJobBoard')" valueKey="id" ></select-field>
    <p><strong>{{this.$t('jobs.companyEmail')}}</strong></p>
    <text-field :label="this.$t('jobs.enterTheEmail')" :placeholder="this.$t('jobs.enteremail')" v-model.trim="email" :error="emailError"  />
    <p v-html="this.$t('jobs.pleaseEnter')"></p>
  </main>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import Field from '@/components/general/field'
import TextField from '@/components/general/text-field'
import SelectField from '@/components/general/select-field'
export default {
  components: { Field, TextField, SelectField },
  props: ['emailError', 'jobBoardError'],
  computed: {
    ...mapState('companyForm', {
      formEmail: 'inviteCompanyEmail',
      formSelectedJobBoard: 'selectedJobBoard'
    }),
    ...mapState('jobs', {
      jobBoards: 'jobBoards'
    }),
    email: {
      get () { return this.formEmail },
      set (value) { this.setInviteCompanyEmail(value) }
    },
    jobBoard: {
      get () { return this.formSelectedJobBoard },
      set (value) { this.setSelectedJobBoard(value) }
    }
  },
  methods: {
    ...mapMutations('companyForm', ['setInviteCompanyEmail', 'setSelectedJobBoard'])
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/companies/invite-company-form.vue